<template>
  <div class="my-share-page page-padding-top">
    <top-bar :title="i18n.t('share.title3')" parentId=".notice-page" @back="back"></top-bar>

    <div class="share-statistics flex-center">
      <div class="flex-1 flex-column-start-center">
        <div class="label">{{$t('share.label6')}}</div>
        <div class="count">{{statisticsData.Total}}</div>
      </div>
      <div class="flex-1 flex-column-end-center">
        <div class="label">{{$t('share.label7')}}(USDT)</div>
        <div class="count">{{statisticsData.TotalIncome}}</div>
      </div>
    </div>

    <div class="page-title" v-if="isInit && shareList.length > 0">{{$t('share.label8')}}</div>

    <div class="share-list">

        <div class="list " v-for="(item, i) in shareList" :key="i" @click="toBuy(item)">
          <div class="title">UID: {{item.UId}}</div>
          <div class="flex-center share-statistics">
            <div class="flex-column-center flex-1">
              <div class="label">{{$t('share.label9')}}</div>
              <div class="count">{{item.TradeVolume}}</div>
            </div>
            <div class="flex-column-center flex-1">
              <div class="label">{{$t('share.label10')}}</div>
              <div class="count">{{item.Income}}</div>
            </div>
          </div>
        </div>

      <div class="empty-box flex-column-center" v-if="isInit && shareList.length == 0">
        <img :src="emptyUrl" alt="">
        <span>{{$t('common.empty')}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { shareStatistics } from '@/api/user'
import topBar from '@/components/topBar'
import { List } from 'vant'
export default {
  components: {
    topBar,
    List
  },
  data() {
    return {
      emptyUrl: require('../../assets/imgs/order-empty.png'),
      isInit: false,
      finishedText: '',
      shareList: [],
      page: {
        page: 1,
        limit: 10
      },
      loading: false,
      finished: false,
      totalPage: 1,
      statisticsData: {
        Total: 0,
        TotalIncome: 0,
      }
    }
  },
  mounted() {
    this.isInit = true
    this.loading = false
    this.finished = true
    this.init()
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    init(isAdd) {
      let form = new FormData()
      form.append('current', this.page.page)
      form.append('pageSize', this.page.limit)
      shareStatistics(form).then(res => {
        let data = res.data
        this.shareList = data.InviteList || []
        this.statisticsData = data
        this.isInit = true
      })
    },
  }
}
</script>